import React from "react";

const Header = () => {
  return (
    <header className="header">
      <button className="nav-toggle" title="Expand Collapse Navigation">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div className="logo">
        <a
          href="javascript:void(0)"
          title="ServoFeat - Serving a smartest technology"
          className="text-white"
        >
          {/* <img src="assets/images/logo.png" alt="Logo" /> */}
          <h4> Servofeat</h4>
        </a>
      </div>
    </header>
  );
};
export default Header;
